module.exports = __webpack_public_path__ + "img/rebase.16701f14.png";